import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate';
import Cookies from 'js-cookie';
// import authenticate from './modules/authenticate';
// import driverProfile from './modules/driver-profile';
// import driverGrades from './modules/driver-grades';
// import policies from './modules/policies';
// import manufacturers from './modules/manufacturers';

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    data: {}
  },
  modules: {
    // authenticate,
    // driverProfile,
    // driverGrades,
    // policies,
    // manufacturers,
  },
  plugins: [
    createPersistedState({
      storage: {
        getItem: key => Cookies.get(key),
        setItem: (key, value) =>
          Cookies.set(key, value, { expires: 3, secure: true }),
        removeItem: key => Cookies.remove(key)
      }
    })
  ]
})
